<template>
  <div class="dropload">
    <input type="file" id="image" accept="image/png, image/jpeg, image/gif" @input="previewImage" ref="uploadInput" />
    <transition name="fade" mode="out-in">
      <label v-if="!loading" for="image">
        <Button class="icon round primary" icon="bi-cloud-upload" />
        <p class="bold">{{ $t("other.dropload.text") }}</p>
        <p class="muted" v-safe-html="$t('other.dropload.info')"></p>
      </label>
      <div v-else class="spinner-container">
        <img class="spinner" src="@/assets/images/element/spinner.png" alt="Spinner" />
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useToast } from "vue-toastification";

const uploadInput = ref(null);

const toast = useToast();

const emits = defineEmits(["update:modelValue"]);

defineProps({
  modelValue: {
    type: [String, null, File],
    required: true,
  },
  loading: {
    type: Boolean,
    required: false,
  },
});

async function previewImage() {
  const [file] = uploadInput.value.files;

  const maxSize = 1024 * 1024; // 1Mo

  if (!["image/png", "image/jpeg", "image/gif"].includes(file.type)) {
    toast.error(t('other.error.ERROR_UNSUPPORTED_FORMAT'));
    return;
  }

  if (file.size > maxSize) {
    toast.error(t('other.error.IMAGE_TOO_HEAVY', { size: 1 }));
    return;
  }

  emits("update:modelValue", file);
}
</script>
